import {mapActions} from "vuex";

export const courseMixins = {
    data() {
        return {
            formData: {
                avatarId: null,
                material: "",
                materialUrl: "",
                classSubjectId: null,
                classSubjectName: "",
                id: null,
                name: "",
                nickname: "",
                // tags: [],
                tagValueIdList: [],
                target: [],
                category: 0,
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur"],
                    },
                ],
                // nickname: [
                //   {
                //     required: true,
                //     message: "请输入",
                //     trigger: ["blur"],
                //   },
                // ],
                "target[0]": [
                    {
                        required: true,
                        message: "请输入",
                        trigger: ["blur"],
                    },
                ],
            },
            options: [],
        };
    },
    methods: {
        ...mapActions("courseCenter", ["saveLesson", "initLessonVersion"]),
        clearForm() {
            this.formData.avatarId = null;
            this.formData.material = "";
            this.formData.materialUrl = "";
            this.formData.classSubjectId = Number(
                this.$Base64.decode(this.$route.params.classSubjectId)
            );
            this.formData.classSubjectName = this.$Base64.decode(
                this.$route.params.classSubjectName
            );
            this.formData.id = null;
            this.formData.name = "";
            this.formData.nickname = "";
            this.formData.tagValueIdList = [];
            this.formData.target = [];
            this.formData.category = 0;
        },
        async handleConfirm() {
            // var type;
            await this.$refs.form.validate(async (valid) => {
                if (valid) {
                    let res = await this.handleSaveLesson();
                    let lessonVersion = await this.initLessonVersion({id: res.data.id});
                    await this.$router.push({
                            name: "MyOutLine",
                            params: {
                                lessonId: this.$Base64.encode(res.data.id),
                                version: this.$Base64.encode(lessonVersion.data.version),
                                classSubjectId: this.$route.params.classSubjectId,
                                classSubjectName: this.$route.params.classSubjectName,
                                type: "edit",
                            },
                        }
                    );
                }
            });
        },
        async handleSaveConfirm() {
            // var type;
            await this.$refs.form.validate(async (valid) => {
                if (valid) {
                    await this.handleSaveLesson();
                    await this.$router.go(-1);
                }
            });
        },
        async handleSaveLesson() {
            const res = await this.saveLesson({
                ...this.formData,
            });
            if (this.formData.id) {
                this.$message.success("编辑成功");
                // type = "edit";
            } else {
                this.$message.success("添加成功");
                // type = "add";
            }
            localStorage.removeItem("isActive");
            localStorage.setItem("lessonResponseDetail", JSON.stringify(res.data));
            return res;
        }
    },
};
